/* libs/iot-platform/iot-platform-feature-app-shell/src/lib/components/header/header.component.scss */
.navbar-business-profile-select {
  max-width: 100%;
  width: auto;
  padding-right: 21px !important;
  font-size: 14px;
  font-weight: 600;
  text-transform: none !important;
}
header {
  height: auto;
  min-height: 56px;
  padding: 0 10px;
  font-size: 14px;
  font-weight: 600;
  background-color: white;
}
img {
  cursor: pointer;
  height: 24px;
  width: auto;
}
.border-right::after {
  content: "";
  margin-left: 21px;
}
.border-left::before {
  content: "";
  margin-right: 21px;
}
.user-button {
  box-shadow: none !important;
  font-size: 16px;
}
.bp-list--bp-name {
  margin-right: 10px;
}
.bp-list--info-icon {
  font-size: 20px;
}
.environment-tag {
  border: 1px solid;
  border-radius: 8px;
  padding: 2px 10px;
  font-size: 12px;
  min-width: 57px;
  text-align: center;
}
/*# sourceMappingURL=header.component.css.map */
